import { DEFAULT_TEMPLATE_IMG } from '@shared/Constants/Images/DefaultTemplateImg';
import { GalleryEntity } from '@entities/Gallery/Types';

export const GetGalleryUrlByFragmentId = (
    fragmentId: number,
    fragmentsGalleryData?: GalleryEntity[]
) => {
    if (fragmentsGalleryData) {
        const gallery = fragmentsGalleryData.find(
            gallery => gallery.galleryableId === fragmentId
        );

        if (gallery && gallery.medias.length > 0) {
            return gallery.medias.at(-1)?.url ?? DEFAULT_TEMPLATE_IMG;
        }
    }

    return DEFAULT_TEMPLATE_IMG;
};
